<template>
  <div v-show="item.status === 'RUNNING'" class="grid grid-cols-3">
    <div
      @click="active = !active"
      v-if="active"
      content="Resultado acumulado do dia"
      v-tippy="{ arrow: true, theme: 'green' }"
      class="cursor-pointer"
    >
      <p class="label_card">Acumulado</p>
      <div class="flex items-center space-x-2">
        <div class="flex items-center space-x-2">
          <div
            v-if="item.closed_pnl + item.position_profit != 0"
            :class="
              item.closed_pnl + item.position_profit > 0
                ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
                : 'text-ontick-red-500 rotate-180'
            "
            v-html="$icons.arrow_drop"
          ></div>

          <span
            class="h-3 w-3 rounded-full bg-gray-400"
            v-show="item.closed_pnl + item.position_profit == 0"
          ></span>
          <p
            class="text-ontick-steel-500 text-left text-sm font-medium dark:text-gray-200"
          >
            {{ (item.closed_pnl + item.position_profit) | currency }}
          </p>
        </div>
      </div>
    </div>
    <div
      @click="active = !active"
      v-else
      content="Resultado da operação em aberto"
      v-tippy="{ arrow: true, theme: 'green' }"
      class="cursor-pointer"
    >
      <p class="label_card text-left">Resultado</p>
      <div class="flex items-center space-x-2">
        <div class="flex items-center justify-center space-x-2">
          <template v-if="item.position_status != 'Zerado'">
            <!-- ICON -->
            <div
              v-if="item.open_pnl"
              :class="
                item.open_pnl > 0
                  ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
                  : 'text-ontick-red-500 rotate-180'
              "
              v-html="$icons.arrow_drop"
            ></div>
            <div
              class="h-3 w-3 rounded-full bg-gray-400"
              v-if="
                item.open_pnl == 0 &&
                getMarketdata[item.strategy_symbol] !== null
              "
            ></div>

            <!-- WAITING -->
            <ontick-loading-ellipsis-component
              v-if="
                getMarketdata[item.strategy_symbol] === null &&
                item.position_status != 'Zerado'
              "
            />

            <!-- RESULT EXISTS -->
            <p
              v-else
              class="text-ontick-steel-500 whitespace-nowrap text-left text-sm font-semibold dark:text-gray-200"
            >
              {{ item.open_pnl | currency }}
            </p>
          </template>
          <p
            class="text-ontick-steel-500 font-medium dark:text-gray-300"
            v-else-if="item.position_status == 'Zerado'"
          >
            -
          </p>
        </div>
      </div>
    </div>
    <div
      content="Volume posicionados/parametrizados"
      v-tippy="{ arrow: true, theme: 'green' }"
    >
      <p class="label_card text-center">Volume</p>
      <p
        class="whitespace-nowrap text-center text-sm font-semibold text-gray-500 dark:text-gray-400"
      >
        <span
          :class="
            item.position_status != 'Zerado'
              ? 'text-ontick-carbon-900 font-bold dark:text-gray-200'
              : 'text-gray-500 dark:text-gray-400'
          "
          >{{
            item.position_volume == 0 && item.position_status == "Zerado"
              ? "-"
              : item.position_volume
          }}</span
        >/<span>{{ item.param_volume }}</span>
      </p>
    </div>
    <div content="Status da posição" v-tippy="{ arrow: true, theme: 'green' }">
      <p class="label_card text-right">Posição</p>
      <p
        :class="
          textPosition(item.position_status) == 'Zerado'
            ? 'text-ontick-steel-500 font-medium dark:text-gray-300'
            : 'text-ontick-yellow-900 dark:text-ontick-yellow-600 font-semibold'
        "
        class="text-right text-sm uppercase"
      >
        {{ textPosition(item.position_status) }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  props: {
    item: { type: Object },
    minimize: { type: Boolean },
  },

  data() {
    return {
      active: false,
    };
  },

  computed: {
    ...mapGetters({ getMarketdata: "marketdata/getMarketdata" }),
    ...mapState({
      position: (state) => state.stream.position,
    }),
  },

  methods: {
    textPosition(value) {
      let label;
      if (value == "BUY" || value == "Comprado") {
        label = "Compra";
      } else if (value == "SELL" || value == "Vendido") {
        label = "Venda";
      } else {
        label = "Zerado";
      }
      return label;
    },
    calcResult(item) {
      return item.open_pnl;
    },
  },

  watch: {
    position: {
      deep: true,
      handler(value) {
        let payload = value.data[0];
        if (this.item.investment_id == payload.investment_id) {
          this.active = payload.position_type != "Vendido" ? false : true;
        }
        return value;
      },
    },
  },

  mounted() {
    if (this.item.position_status == "Zerado") {
      this.active = true;
    } else {
      this.active = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.label_card {
  @apply text-xs text-gray-500 dark:text-gray-400;
}
</style>
